import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { STARS_TITLES } from 'client/constants';
import classNames from 'classnames';
import * as css from './Stars.scss';

const StarsRating = ({ className, ratingClick, disable, votedRate }) => {
	const [isMoving, setIsMoving] = useState(false);
	const [moveUpFullLabel, setMoveUpFullLabel] = useState('');
	const [moveUpHalfLabel, setMoveUpHalfLabel] = useState('');
	const [rate, setRate] = useState(0);

	useEffect(() => {
		if (votedRate > 0) {
			const inputFull = document.getElementById(`rating${votedRate / 10}`);
			inputFull.checked = true;
		}
	}, [votedRate]);

	const handleTouchStart = e => {
		setIsMoving(true);
		document.addEventListener('touchmove', handleTouchMove);
	};

	const handleTouchEnd = e => {
		setIsMoving(false);
		ratingClick(Number(rate));
		document.removeEventListener('touchmove', handleTouchMove);
	};

	const handleTouchMove = e => {
		const changedTouch = e.touches[0];
		const currentEl = document.elementFromPoint(changedTouch.clientX, changedTouch.clientY);

		if (currentEl !== 'null' && currentEl.classList.contains(`${css.path}`)) {
			const id = currentEl.closest('label').htmlFor;
			const num = Number(id.replace('rating', ''));
			if (!Number.isInteger(num / 2)) {
				const inputHalf = document.getElementById(id);
				inputHalf.checked = true;

				setMoveUpHalfLabel(id);
				setMoveUpFullLabel(`rating${num + 1}`);

				setRate(inputHalf.value);
			} else {
				const inputFull = document.getElementById(id);
				inputFull.checked = true;
				setRate(inputFull.value);
			}
		}
	};

	const onClick = e => {
		const valueNumeric = Number(e.target.value);
		ratingClick(valueNumeric);
	};

	return (
		<div className={css.starsRating}>
			<div
				className={classNames(css.rate, { [css.move]: isMoving }, { [css.disabled]: disable }, className)}
				onTouchStart={handleTouchStart}
				onTouchEnd={handleTouchEnd}
			>
				<input type="radio" id="rating10" name="rating" value="100" onClick={onClick} />
				<label
					htmlFor="rating10"
					// title="5 stars"
					className={classNames({ [css.moveUp]: moveUpFullLabel === 'rating10' })}
					datatooltip={STARS_TITLES.FIVE}
				>
					<span className={classNames(css.path, css.path1)}></span>
					<span className={classNames(css.path, css.path2)}></span>
				</label>
				<input type="radio" id="rating9" name="rating" value="90" onClick={onClick} />
				<label
					htmlFor="rating9"
					// title="4 1/2 stars"
					datatooltip={STARS_TITLES.FIVE}
					className={classNames(css.half, { [css.moveUp]: moveUpHalfLabel === 'rating9' })}
				>
					<span className={classNames(css.path, css.path3)}></span>
				</label>
				<input type="radio" id="rating8" name="rating" value="80" onClick={onClick} />
				<label
					htmlFor="rating8"
					// title="4 stars"
					datatooltip={STARS_TITLES.FOUR}
					className={classNames({ [css.moveUp]: moveUpFullLabel === 'rating8' })}
				>
					<span className={classNames(css.path, css.path1)}></span>
					<span className={classNames(css.path, css.path2)}></span>
				</label>
				<input type="radio" id="rating7" name="rating" value="70" onClick={onClick} />
				<label
					htmlFor="rating7"
					// title="3 1/2 stars"
					datatooltip={STARS_TITLES.FOUR}
					className={classNames(css.half, { [css.moveUp]: moveUpHalfLabel === 'rating7' })}
				>
					<span className={classNames(css.path, css.path3)}></span>
				</label>
				<input type="radio" id="rating6" name="rating" value="60" onClick={onClick} />
				<label
					htmlFor="rating6"
					// title="3 stars"
					datatooltip={STARS_TITLES.THREE}
					className={classNames({ [css.moveUp]: moveUpFullLabel === 'rating6' })}
				>
					<span className={classNames(css.path, css.path1)}></span>
					<span className={classNames(css.path, css.path2)}></span>
				</label>
				<input type="radio" id="rating5" name="rating" value="50" onClick={onClick} />
				<label
					htmlFor="rating5"
					// title="2 1/2 stars"
					datatooltip={STARS_TITLES.THREE}
					className={classNames(css.half, { [css.moveUp]: moveUpHalfLabel === 'rating5' })}
				>
					<span className={classNames(css.path, css.path3)}></span>
				</label>
				<input type="radio" id="rating4" name="rating" value="40" onClick={onClick} />
				<label
					htmlFor="rating4"
					// title="2 stars"
					datatooltip={STARS_TITLES.TWO}
					className={classNames({ [css.moveUp]: moveUpFullLabel === 'rating4' })}
				>
					<span className={classNames(css.path, css.path1)}></span>
					<span className={classNames(css.path, css.path2)}></span>
				</label>
				<input type="radio" id="rating3" name="rating" value="30" onClick={onClick} />
				<label
					htmlFor="rating3"
					// title="1 1/2 stars"
					datatooltip={STARS_TITLES.TWO}
					className={classNames(css.half, { [css.moveUp]: moveUpHalfLabel === 'rating3' })}
				>
					<span className={classNames(css.path, css.path3)}></span>
				</label>
				<input type="radio" id="rating2" name="rating" value="20" onClick={onClick} />
				<label
					htmlFor="rating2"
					// title="1 star"
					datatooltip={STARS_TITLES.ONE}
					className={classNames({ [css.moveUp]: moveUpFullLabel === 'rating2' })}
				>
					<span className={classNames(css.path, css.path1)}></span>
					<span className={classNames(css.path, css.path2)}></span>
				</label>
				<input type="radio" id="rating1" name="rating" value="10" onClick={onClick} />
				<label
					htmlFor="rating1"
					// title="1/2 star"
					datatooltip={STARS_TITLES.ONE}
					className={classNames(css.half, { [css.moveUp]: moveUpHalfLabel === 'rating1' })}
				>
					<span className={classNames(css.path, css.path3)}></span>
				</label>
			</div>
		</div>
	);
};

StarsRating.propTypes = {
	className: PropTypes.string,
	ratingClick: PropTypes.func.isRequired,
	disable: PropTypes.bool.isRequired,
	votedRate: PropTypes.number.isRequired,
};

StarsRating.defaultProps = {
	className: '',
};

export default StarsRating;
